import { Severity } from 'types/cases';

export const findDefaultSeverity = (data: Severity[]) =>
    data.find((item) => item.isDefault) || data[0];
